import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonLabel,
   IonItem,
   IonInput,
   IonCard,
   IonCardHeader,
   IonCardSubtitle,
   IonCardTitle,
   IonCardContent,
   useIonViewWillEnter,
   useIonRouter
} from '@ionic/react';

import { LANGUAGE, GetStr } from "../language/Language";
import { RouteComponentProps } from "react-router-dom";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import NumInputCtrl from "../components/NumInputCtrl";

import './Main.css';  


interface WithdrawAmountData extends RouteComponentProps<{
    address : string
    }> 
{} 

const WithdrawAmount : React.FC<WithdrawAmountData> = ({match}) => {

    //	Initializing our router
	const router = useIonRouter();
    const [amount, setAmount] = useState("0");

    useIonViewWillEnter(() => {
    });

    // when save the passcode
    const submit = async () => {
        router.push('/withdrawconfirm/' + match.params.address + "/" + amount, "forward", "push");
    }

    return (
    <IonPage>
        <IonContent>
            <div id="main-bk" />
            <IonToolbar color="none">
                <IonButtons slot="start">
                    <IonBackButton text="" defaultHref="/withdraw" ></IonBackButton>
                </IonButtons>
            </IonToolbar>
            <IonGrid className="ion-no-padding main-content">
                <IonRow>
                    <IonCol>
                    </IonCol>
                    <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                        <IonCard className="flat-card">
                            <IonCardHeader>
                                <IonCardSubtitle>{ GetStr(LANGUAGE.TXT_QUICKW_CAP) }</IonCardSubtitle>
                                <IonCardTitle>{match.params.address}</IonCardTitle>
                            </IonCardHeader>
                        </IonCard>
                        <NumInputCtrl 
                            amount={ amount }
                            caption={ GetStr(LANGUAGE.TXT_QUICKW_LBL) } 
                            button={ GetStr(LANGUAGE.TXT_WIDTHDRAW_DO) } 
                            deci={ true }
                            onChange={setAmount} 
                            onSubmit={submit} 
                        />
                    </IonCol>
                    <IonCol>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonContent>
    </IonPage>
    );
}

export default WithdrawAmount;